import { forwardRef, type InputHTMLAttributes } from 'react'
import { cn } from '@/lib/utils'
import { useFieldControl } from '@/components/portal/PortalField'

export const PortalInput = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, id, ...props }, ref) => {
    const field = useFieldControl()
    const invalid = props['aria-invalid'] ?? (field?.invalid ? true : undefined)
    return (
      <input
        ref={ref}
        {...props}
        id={id ?? field?.id}
        aria-invalid={invalid}
        aria-describedby={props['aria-describedby'] ?? field?.describedBy}
        className={cn('prod-input', invalid && 'prod-input--invalid', className)}
      />
    )
  },
)
PortalInput.displayName = 'PortalInput'
